import { Action } from '@ngrx/store';
import { ActionOptionsArgs, BaseAction, SynchronisableAction } from '../../../core/store/actions/base-actions';
import { BaseObjectFilters } from '../../store/bootstrap';
import { LookupType } from './lookup-type.model';

export const ENTITY = 'lookupType';
export const REHYDRATE = '[LookupType] Rehydrate';
export const REMOVE = '[LookupType] Remove';
export const SUBMIT = '[LookupType] Submit';
export const SET_FILTER = '[LookupType] Set Filter';

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: LookupType, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly type = REHYDRATE;

    constructor(public payload: Array<LookupType>) {

    }
}
export class RemoveAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: LookupType, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class SetFilterAction extends BaseAction {
    readonly type = SET_FILTER;
    readonly entity = ENTITY;

    constructor(public payload: BaseObjectFilters, options?: ActionOptionsArgs) {
        super(payload, options);
    }
}

export type Actions
    = SubmitAction
    | RehydrateAction
    | RemoveAction
    | SetFilterAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/lookup-type/lookup-type.actions.ts